<template>
  <el-select v-model="dealerId"
             filterable
             remote
             :multiple="multiple"
             :reserve-keyword="multiple"
             clearable=""
             placeholder="请输入客户名称查询"
             :remote-method="remoteMethod"
             :loading="loading">
    <el-option v-for="item in options"
               :key="item.dealerId"
               :label="item.dealerName"
               :value="item.dealerId">
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'OwnerSelect',
  props: {
    value: { type: [Number, String, Array], default: '' },
    multiple: { type: Boolean, default: false }
  },
  data () {
    return {
      loading: false,
      options: []
    }
  },
  computed: {
    dealerId: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    remoteMethod (dealerName) {
      if (dealerName.trim().length >= 2) {
        this.$store.dispatch('delivery/getdealers', {
          payload: { pageNum: 1, pageSize: 50, dealerName },
          success: (res) => {
            this.options = res.data.records
          },
          fail: () => {
            this.options = []
          }
        })
      } else {
        this.options = []
      }
    }
  }
}
</script>
